if (document.querySelector('.wpcf7-form')) {

    getGlobalElementsHeight(); // gets height of header and footer combined, so that the footer can be pushed down to the bottom of the page

    const form = document.querySelector('.inquire-form .wpcf7-form');

    form.querySelectorAll('.input:not(.radio)').forEach((formField) => {

        let options = {
            childList: true,
            subtree:true
        },

        observer = new MutationObserver(mCallback);

        function mCallback(mutations) { // Mutation observer to listen for validation messages in child
            for (let mutation of mutations) {
                if (mutation.type === 'childList') {

                    if (mutation.target.parentNode.querySelector('.wpcf7-not-valid-tip')){
                        mutation.target.parentNode.classList.add('invalid'); // Add invalid class to parent

                        mutation.target.querySelector('input').focus(); //Focus on input with error
                        let fieldName = mutation.target.querySelector('input').getAttribute('name'); //Get field name
                        mutation.target.querySelector('.wpcf7-not-valid-tip').setAttribute('id', "error-"+fieldName); //Use field name to add ID to error message
                        mutation.target.querySelector('input').setAttribute('aria-describedby', "error-"+fieldName); // aria describedby to error
                    }
                }
            }
        }

        observer.observe(formField, options);

        let input = null;

        if (formField.querySelector('input')) {
            input = formField.querySelector('input');
        }

        if (formField.querySelector('textarea')) {
            input = formField.querySelector('textarea');
        }

        if (input) {
            function inputChange() {
                formField.classList.add('changed');
            }

            function inputReset() {
                formField.classList.remove('changed');
            }

            input.addEventListener('change', () => {
                inputChange();
                if (input.value === '') {
                    inputReset();
                }
            });

            input.addEventListener('focusin', inputChange);
            input.addEventListener('focusout', () => {

                if (!formField.querySelector('.wpcf7-not-valid-tip')) { // Get rid of invalid styles
                    formField.classList.remove('invalid')
                }

                if (input.value === '') {
                    inputReset();
                }
            });
        }
    });

    if (document.querySelector('.wpcf7-response-output')) {
        const back = document.querySelector('.wpcf7-response-output');
    }

    form.addEventListener( 'wpcf7mailsent', () => {
        const formOuter = document.querySelector('.form');
        formOuter.classList.add('success');
        window.scrollTo(0, 0);

        form.querySelectorAll('.input:not(.radio)').forEach((formField) => {
            formField.classList.remove('changed');
        });

        setTimeout(() => {
            formOuter.classList.remove('success');
            formOuter.classList.add('submitted');
        }, 3000)
    }, false );



    // Resize event
    // window.addEventListener('resize', () => {
    //     getGlobalElementsHeight();
    // });


    function getGlobalElementsHeight() {
        //get the height of two elements and add them to a variable
        let headerHeight = document.querySelector('header#site-header').offsetHeight;
        let footerHeight = document.querySelector('footer#site-footer').offsetHeight;
        let totalHeight = headerHeight + footerHeight;
        console.log(totalHeight);
        document.querySelector(':root').style.setProperty('--header-footer-height', `${totalHeight}px`);
    }
}

